const FeatureData = [
    {
        icon : 'clock',
        title : "Opening hours",
        description : 'Lorem ipsum dolor sit amet.',
        bg: 'bg-primary'
    },
    {
        icon : 'location',
        title : "Visit our location",
        description : 'Lorem ipsum dolor sit amet.',
        bg: 'bg-dark'
    },
    {
        icon : 'contact',
        title : "Contact us now",
        description : '+880-1985-335245',
        bg: 'bg-primary'

    },
]

export default FeatureData;